export default __webpack_public_path__ + "static/media/business_show_5_en.54c4c3b7.png";